import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const ProfileInfoNotice: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="mt-8 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                        <FontAwesomeIcon icon={faUser} className="text-blue-600 dark:text-blue-400" />
                    </div>
                </div>
                <div className="ml-4">
                    <h3 className="text-lg font-medium text-blue-900 dark:text-blue-100">
                        {t('profile.components.profileInfoNotice.title')}
                    </h3>
                    <div className="mt-2 text-sm text-blue-800 dark:text-blue-200">
                        <p className="mb-2">
                            {t('profile.components.profileInfoNotice.description1')}
                        </p>
                        <p>
                            {t('profile.components.profileInfoNotice.description2')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileInfoNotice;